// Imports => Dependencies
import { useContext } from 'react';

// Imports => StoreContext
import { StoreContext } from '@stores';

// Imports => Constants
import { PERMISSIONS } from '@constants';

// Imports => Utilities
import { AcIsSet, AcIsNull, AcIsArray } from '@opp/ui-kit';
import { useAppSelector } from '@src/rtk/hooks';

export const usePermissions = () => {
  const {currentRoles, currentPermissions} = useAppSelector(state => state.auth);

  const is = (role, collection) => {
    let arr = currentRoles;

    if (AcIsSet(collection)) arr = collection;
    if (!AcIsSet(arr)) return false;

    return arr.indexOf(role) > -1;
  };

  const canAssignRoles = () => {
    let count = 0;

    if (can(PERMISSIONS.USER.CREATE_COMPANY_ADMIN)) count = count + 1;
    if (can(PERMISSIONS.USER.CREATE_OPERATOR)) count = count + 1;
    if (can(PERMISSIONS.USER.CREATE_RENTAL_COORDINATOR)) count = count + 1;
    if (can(PERMISSIONS.USER.CREATE_SERVICE_ENGINEER)) count = count + 1;

    return count > 1;
  };

  const can = (action) => {
    if (AcIsNull(action)) return true;

    if (!AcIsSet(currentPermissions)) return false;

    if (AcIsArray(action)) {
      const len = action.length;
      let n = 0;
      let result = false;

      for (n; n < len; n++) {
        const line = action[n];

        if (currentPermissions[line]) {
          result = true;
          break;
        }
      }

      return result;
    } else {
      return currentPermissions[action];
    }
  };

  const cannot = (permission) => {
    return !can(permission);
  };

  return {
    is,
    can,
    cannot,
    canAssignRoles,
  };
};
